import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { ILostFound } from "@/domain/entities/bbs/lostFound/lostFound.types";
import LostFoundRow from "./LostFoundRow.vue";


const __default__ = {
  name: "FoundList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  foundList: {
    type: Array as PropType<ILostFound[]>,
    required: true,
  },
  emptyText: {
    type: String,
    default: "습득물이 없습니다.",
  },
},
  emits: ["onClickRow"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const emitOnClickRow = (lostFound: ILostFound) => {
  emit("onClickRow", lostFound);
};

const __returned__ = { emit, emitOnClickRow, LostFoundRow }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})